/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useEffect, useState } from "react";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";

const HighlightImage = (props) => {

    const _image = props?.image;
    const imageCard = props?.imageCard;
    const settings = props?.settings;
    const { token } = useAuth();
    const [image, setImage] = useState();
    const isVertical = imageCard === "vertical";
    const direction = isVertical ? `vertical` : `horizontal`;
    const alt = image?.alt;
    const url = image?.url;
    const image_settings = settings?.image_settings;
    const options = image_settings?.options;
    const position = options?.position ?? "center center";
    const image_style = {
        backgroundImage: `url(${url})`,
        backgroundPosition: position,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
    };

    const getImage = async () => {
        if (_image) {
            const img = await SimpliCitySDK.image.findOne(token, _image);
            setImage(img);
        }
    };

    useEffect(() => {
        getImage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_image]);


    return (
        <>
            {image &&
                <div
                    className={`simplicity-cta-content-image ${direction}`}
                    style={image_style}
                    title={alt}
                />
            }
        </>
    );
};

export { HighlightImage };
